import {Accordion, Spinner} from "react-bootstrap";
import AppContext from "../contexts/app-context";
import {useContext, useEffect, useState} from "react";
import * as backendUtils from "../helper/BackendUtils";
import {toast} from "react-toastify";
import EventBarChart from "../components/EventBarChart";
import {useParams} from "react-router-dom";

export default function Events() {
    const {id}  = useParams();
    const context = useContext(AppContext);
    const [error, setError] = useState(null);
    const [userId, setUserId] = useState("");
    const [activeEvents, setActiveEvents] = useState([]);
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [selectedEvent] = useState(id ? id : "0");

    useEffect(() => {
        const loadActiveEvents = () => {
            if (context.backendUri && userId) {
                setShowSpinner(true);
                backendUtils.getRequest(`${context.backendUri}/event/`, {},
                    response => {
                        const enabled = response.data.filter(e => e.enabled);
                        const now = new Date();
                        now.setUTCHours(0,0,0,0)
                        const current = enabled.filter(e => new Date(e.startDate) <= now && new Date(e.endDate) >= now);
                        setActiveEvents(current.sort((a, b) => new Date(b.startDate) - new Date(a.startDate)));
                        const upcoming = enabled.filter(e => new Date(e.startDate) > now);
                        setUpcomingEvents(upcoming.sort((a, b) => new Date(b.startDate) - new Date(a.startDate)));
                        const past = enabled.filter(e => new Date(e.endDate) < now);
                        setPastEvents(past.sort((a, b) => new Date(b.startDate) - new Date(a.startDate)));
                    }, err => {
                        setError(backendUtils.getErrorMessage(err));
                    }
                ).then(() => setShowSpinner(false))
                    .catch((err) => setError(err))
            }
        }
        loadActiveEvents();
    }, [context.backendUri, userId])

    useEffect(() => {
        setUserId(context.userId)
    }, [context.userId])

    useEffect(() => {
        if (error) {
            console.log(error)
            toast(error)
        }
    }, [error])

    return (
        <div>
            <div className="text-center m-2"><Spinner animation="border" variant="primary" hidden={!showSpinner}/></div>
            <Accordion defaultActiveKey="0" flush>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Active Events</Accordion.Header>
                    <Accordion.Body>
                        <Accordion defaultActiveKey={selectedEvent}>
                        {
                            activeEvents?.map(e => {
                            return (<Accordion.Item eventKey={e.id.toString()}>
                                <Accordion.Header>{e.name}</Accordion.Header>
                                <Accordion.Body>
                                    <h5 className="text-center h5">{e.startDate}&#10230;{e.endDate}</h5>
                                    <EventBarChart email={userId} event={e} key={e.id}/>
                                </Accordion.Body>
                            </Accordion.Item>)
                        })}
                        </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Upcoming Events</Accordion.Header>
                    <Accordion.Body>
                        <Accordion>
                            {upcomingEvents?.map(e => {
                                return (<Accordion.Item eventKey={e.id.toString()}>
                                    <Accordion.Header>{e.name}</Accordion.Header>
                                    <Accordion.Body>
                                        <h5 className="text-center h5">{e.startDate}&#10230;{e.endDate}</h5>
                                        <EventBarChart email={userId} event={e}/>
                                    </Accordion.Body>
                                </Accordion.Item>)
                            })}
                        </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Past Events</Accordion.Header>
                    <Accordion.Body>
                        <Accordion>
                            {pastEvents?.map(e => {
                                return (<Accordion.Item eventKey={e.id.toString()}>
                                    <Accordion.Header>{e.name}</Accordion.Header>
                                    <Accordion.Body>
                                        <h5 className="text-center h5">{e.startDate}&#10230;{e.endDate}</h5>
                                        <EventBarChart email={userId} backendUri={context.backendUri} event={e}/>
                                    </Accordion.Body>
                                </Accordion.Item>)
                            })}
                        </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};